import React, { useEffect, useState } from 'react'
import { Button } from '@/components/atoms/index'
import { useNavigate, useLocation } from 'react-router-dom'
import { AcademyWordTabItems } from '@/pages/academy/word/list'
import AcademyVocabularyTable from '@/components/organisms/Table/AcademyVocabularyTable'
import { academyWordbookApi } from '@/services/api'
import { useSessionSlug } from '@/hooks/useSessionSlug'
interface WordbookData {
  id: string
  wordbookName: string
  wordCount: number
  isPublic: boolean
  registrant: string
  createdAt: string
  ownerAcademyCode?: string | null
  ownerAcademyName?: string | null
  ownedByCurrentAcademy?: boolean
  sequenceNo?: number
}

export default function AcademyWordbookList() {
  const navigate = useNavigate()
  const location = useLocation()
  const { academyCode: sessionAcademyCode, status: sessionStatus } = useSessionSlug()
  const academyCode = sessionAcademyCode || ''
  const [searchText, setSearchText] = useState('')
  const [rows, setRows] = useState<WordbookData[]>([])
  const [page, setPage] = useState(1)
  const pageSize = 10
  const [totalPages, setTotalPages] = useState(1)
  const [totalElements, setTotalElements] = useState(0)
  const [publicFilter, setPublicFilter] = useState<boolean | null>(null)

  const fetchList = async (p = page, overrideQ?: string, overridePublic?: boolean | null) => {
    try {
      if (!academyCode) return
      const q = typeof overrideQ === 'string' ? overrideQ : searchText
      const isPublic = typeof overridePublic !== 'undefined' ? overridePublic : publicFilter
      
      console.log('🔍 API 호출 시작:', { q, isPublic, page: p - 1, size: pageSize })
      
      // @ts-ignore
      const res = await academyWordbookApi.list({ q, isPublic: isPublic === null ? undefined : isPublic, academyCode, page: p - 1, size: pageSize })
      
      console.log('📦 API 응답:', res)
      
      // ApiResponse 구조: res = { data: { content: [], totalElements: n, ... } }
      const apiData = res?.data || res
      const content = apiData?.content || []
      const total = apiData?.totalElements ?? 0
      
      console.log('✅ 변환된 데이터:', { content, total })
      
      const pageStartIndex = (p - 1) * pageSize
      setRows(content.map((item: any, idx: number) => {
        const ownerCode = item.ownerAcademyCode || null
        const ownerName = item.ownerAcademyName || null
        const sequenceBase = total > 0
          ? total - (pageStartIndex + idx)
          : content.length - idx
        return {
          id: String(item.id),
          wordbookName: item.title,
          wordCount: item.itemCount || 0,
          isPublic: !!item.isPublic,
          registrant: item.registrant || '',
          createdAt: (item.createdAt || '').toString().substring(0, 10),
          ownerAcademyCode: ownerCode,
          ownerAcademyName: ownerName,
          ownedByCurrentAcademy: !ownerCode || ownerCode === academyCode,
          sequenceNo: sequenceBase > 0 ? sequenceBase : 1
        }
      }))
      setPage(p)
      setTotalElements(total)
      setTotalPages(Math.max(1, Math.ceil(total / pageSize)))
    } catch (error) {
      console.error('❌ API 호출 에러:', error)
      setRows([])
      setTotalElements(0)
      setTotalPages(1)
    }
  }

  useEffect(() => {
    if (sessionStatus !== 'ready' || !academyCode) return;
    const params = new URLSearchParams(location.search)
    const pParam = Number(params.get('page') || '1')
    const qParam = params.get('q') || ''
    const publicParam = params.get('isPublic')
    
    if (searchText !== qParam) setSearchText(qParam)
    
    let publicValue: boolean | null = null
    if (publicParam === 'true') publicValue = true
    else if (publicParam === 'false') publicValue = false
    
    if (publicFilter !== publicValue) setPublicFilter(publicValue)
    
    fetchList(pParam, qParam, publicValue)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, academyCode, sessionStatus])

  const handleRowClick = (wordbookId: string) => {
    navigate(`/academy/word/word_book/detail/${wordbookId}`)
  }

  const handleSearchChange = (text: string) => {
    setSearchText(text)
  }

  const handleSearch = (text: string) => {
    console.log('🔎 검색 실행:', text)
    const params = new URLSearchParams()
    params.set('page', '1')
    if (text) params.set('q', text)
    if (publicFilter !== null) params.set('isPublic', String(publicFilter))
    navigate(`/academy/word/word_book/list?${params.toString()}`)
  }

  const handlePublicFilterChange = (isPublic: boolean | null) => {
    setPublicFilter(isPublic)
    const params = new URLSearchParams()
    params.set('page', '1')
    if (searchText) params.set('q', searchText)
    if (isPublic !== null) params.set('isPublic', String(isPublic))
    navigate(`/academy/word/word_book/list?${params.toString()}`)
  }

  return (
    <main className='flex flex-col flex-1 pt-8'>
      <div className='flex flex-row justify-between items-start'>
        <h1 className='heading1'>단어 관리</h1>
        <Button intent="primary" onClick={() => navigate('/academy/word/word_book/detail')}>
          단어장 추가
        </Button>
      </div>

      <AcademyWordTabItems activeTab='wordbook' setActiveTab={() => {}} />
        <div className='flex flex-col flex-1 justify-between'>
            
        <AcademyVocabularyTable 
            wordbookData={rows} 
            onRowClick={handleRowClick} 
            searchText={searchText} 
            onSearchChange={handleSearchChange}
            onSearchSubmit={(text) => handleSearch(text)}
            onPublicFilterChange={handlePublicFilterChange} 
            currentPage={page} 
            totalPages={totalPages}
            totalElements={totalElements}
            pageSize={pageSize}
            onPageChange={(p)=> {
              const params = new URLSearchParams()
              params.set('page', String(p))
              if (searchText) params.set('q', searchText)
              if (publicFilter !== null) params.set('isPublic', String(publicFilter))
              navigate(`/academy/word/word_book/list?${params.toString()}`)
            }} 
            type='wordbook'
            pagination={true}
        />

        </div>

    </main>
  )
}